import { useMemo, useCallback } from 'react';
import { useLang } from '../i18n';
import { useLists } from '../context';

/**
 * Localized list names. Built-ins use their translated strings; a renamed or custom
 * list shows what staff typed (auto-translated in Telugu, like item names).
 */
export function useListNames() {
  const { t, ln } = useLang();
  const { catById } = useLists();
  const resolve = useCallback(x => (typeof x === 'string' ? catById(x) : x), [catById]);
  const name = useCallback(x => {
    const l = resolve(x);
    if (l.unknown) return t('lists.unknown');
    return l.renamed ? ln(l.label) : t(`cat.${l.id}`);
  }, [resolve, t, ln]);
  const short = useCallback(x => {
    const l = resolve(x);
    if (l.unknown) return t('lists.unknown');
    return l.renamed ? ln(l.short) : t(`catShort.${l.id}`);
  }, [resolve, t, ln]);
  return useMemo(() => ({ name, short }), [name, short]);
}
